import React from 'react';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { ContentProductsCarousel } from '../../Products';
export var FundMostViewedFunds = function FundMostViewedFunds(_ref) {
  var productType = _ref.productType,
    funds = _ref.funds,
    subscriptions = _ref.subscriptions,
    _onFollow = _ref.onFollow,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA;
  var literal = getProductTypeLabel(productType, 'shortPlural', 'lowercase');
  return React.createElement(ContentProductsCarousel, {
    withSPA: withSPA,
    title: "Los ".concat(literal, " m\xE1s vistos"),
    subtitle: "".concat(productType.plural, " m\xE1s vistos en Finect en los \xFAltimos 7 d\xEDas"),
    products: funds.items,
    subscriptions: subscriptions || [],
    onFollow: function onFollow(id, status) {
      return _onFollow ? _onFollow(id, status) : function () {};
    },
    fetching: funds.fetching,
    variant: "large",
    bottomMargin: true
  });
};